import { render, staticRenderFns } from "./LaunchpadPresale.vue?vue&type=template&id=403a027d&"
import script from "./LaunchpadPresale.vue?vue&type=script&lang=ts&"
export * from "./LaunchpadPresale.vue?vue&type=script&lang=ts&"
import style0 from "./LaunchpadPresale.vue?vue&type=style&index=0&id=403a027d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports